module.exports = __webpack_public_path__ + "static/media/picture-10@2x.dcf27eb8.png";